import { render, staticRenderFns } from "./SettlementSummaryChip.vue?vue&type=template&id=5bdde780&scoped=true&lang=pug"
import script from "./SettlementSummaryChip.vue?vue&type=script&lang=ts"
export * from "./SettlementSummaryChip.vue?vue&type=script&lang=ts"
import style0 from "./SettlementSummaryChip.vue?vue&type=style&index=0&id=5bdde780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdde780",
  null
  
)

export default component.exports